/**
 * Derive the OAuth2 authorization URL from the token URL.
 *
 * Handles Microsoft, Google, and generic OAuth2 providers.
 */
export const deriveAuthorizationUrl = (tokenUrl: string): string | null => {
  if (!tokenUrl) {
    return null;
  }

  // Microsoft: replace /token with /authorize
  if (tokenUrl.includes('login.microsoftonline.com')) {
    return tokenUrl.replace(/\/token\/?$/, '/authorize');
  }

  // Google: map token endpoint to authorization endpoint
  if (tokenUrl.includes('oauth2.googleapis.com/token')) {
    return 'https://accounts.google.com/o/oauth2/v2/auth';
  }

  // Generic fallback: replace last "token" segment with "authorize"
  return tokenUrl.replace(/\/token\/?$/, '/authorize');
};

/**
 * Build a full OAuth2 authorization URL with query parameters.
 */
export const buildAuthorizationUrl = (
  authEndpoint: string,
  clientId: string,
  scope: string,
  redirectUri: string
): string => {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    access_type: 'offline',
    prompt: 'consent',
  });

  if (scope) {
    params.set('scope', scope);
  }

  return `${authEndpoint}?${params.toString()}`;
};
